import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/services/apiConfig';
import { OrganizationOverviewData } from '@/shared/types/overviewTypes';
import { SingleResponse } from '@/shared/types/responseTypes';

// Single-account overview: wire returns `data.results` with exactly one `{ organizationId, name, summary }`.
export const useCustomerOrganizationOverview = (customerId: string | undefined) => {
  return useQuery({
    queryKey: ['customer-overview', customerId],
    queryFn: async () => {
      const response = await apiClient.get<SingleResponse<OrganizationOverviewData>>(
        `/api/v1/customers/${customerId}/overview`
      );
      return response?.data;
    },
    enabled: !!customerId,
  });
};